import { createContext, useEffect, useState } from 'react';
import moment from 'moment';
import axiosInstance from '@utils/axios';

const initialState = {};

const DateTimeContext = createContext(initialState);

function DateTimeProvider({ children }) {
  const [dateFormat, setDateFormat] = useState("");
  const [timeFormat, setTimeFormat] = useState("");
  const [dateTimeFormat, setDateTimeFormat] = useState("");

  // const getCompanySetting = async () => {
  //   await axiosInstance.get(`/admin/company/company_settings`).then((response) => {
  //     if (response.status === 200) {
  //       const { data } = response;
  //       setDateFormat(data?.date_format)
  //       setTimeFormat(data?.time_format)
  //       setDateTimeFormat(data?.date_time_format)
  //     }
  //   });
  // }

  // useEffect(() => {
  //   getCompanySetting()
  // }, [])

  useEffect(() => {
    setDateFormat(localStorage.getItem('date_format'))
  }, [localStorage.getItem('date_format')])

  useEffect(() => {
    setDateTimeFormat(localStorage.getItem('date_time_format'))
  }, [localStorage.getItem('date_time_format')])

  const dateFormatType = () => {
    let format = "DD-MM-YYYY";
    if (dateFormat === "d-m-Y") {
      format = "DD-MM-YYYY";
    } else if (dateFormat === "m-d-Y") {
      format = "MM-DD-YYYY";
    } else if (dateFormat === "d/m/Y") {
      format = "DD/MM/YYYY";
    } else if (dateFormat === "m/d/Y") {
      format = "MM/DD/YYYY";
    }
    return format;
  }

  const dateTimeFormatType = () => {
    let formatTime = "DD-MM-YYYY h:m A";
    if (dateTimeFormat === "d-m-Y h:i A") {
      formatTime = "DD-MM-YYYY h:m A";
    } else if (dateTimeFormat === "m-d-Y h:i A") {
      formatTime = "MM-DD-YYYY h:m A";
    } else if (dateTimeFormat === "d/m/Y h/i A") {
      formatTime = "DD/MM/YYYY h/m A";
    } else if (dateTimeFormat === "m/d/Y h/i A") {
      formatTime = "MM/DD/YYYY h/m A";
    }
    return formatTime;
  }

  const dateFormatConvertByMoment = (date) => {
    if (!date || date === null) return;
    return moment(date).format(dateFormatType())
  }

  const timeFormatConvert = (time) => {
    return moment(time).format(timeFormat)
  }

  const dateTimeFormatConvert = (dateTime) => {
    if (!dateTime || dateTime === null) return;
    return moment(dateTime).format(dateTimeFormatType())
  }

  return (
    <DateTimeContext.Provider
      value={{ dateFormat, timeFormat, dateTimeFormat, dateFormatType, timeFormatConvert, dateTimeFormatConvert, dateFormatConvertByMoment }}
    >
      {children}
    </DateTimeContext.Provider>
  );
}

export { DateTimeProvider, DateTimeContext };